import { useSaleType } from "@website/ticket-ui/common/components/sale-type-old/hook";
import { SaleTypePropertiesType } from "@website/ticket-ui/common/components/sale-type-old/types";
import { Chips } from "@website/ui-old/chips";
import { ListItem } from "@website/ui-old/list-item";
import { MiniPopover } from "@website/ui-old/mini-popover";
import { FC } from "react";

export const SaleTypeOld: FC<SaleTypePropertiesType> = (properties) => {
  const { chipsProps, list, popoverProps } = useSaleType(properties);

  return (
    <div className="relative">
      <Chips {...chipsProps} />
      <MiniPopover {...popoverProps}>
        <div className="flex flex-1 flex-col overflow-hidden">
          <div className="flex-1 overflow-y-auto">
            {list.map((item) => (
              <ListItem key={item.title} {...item} />
            ))}
          </div>
        </div>
      </MiniPopover>
    </div>
  );
};
